import apiClient from './axios.config';
import { API_ENDPOINTS } from '../../constants';

/**
 * Travel Request Types API service
 */
export const travelRequestTypesAPI = {
    /**
     * Get all travel request types
     * @param {Object} params - Query parameters
     * @returns {Promise} API response
     */
    getAll: (params = {}) => {
        return apiClient.get(API_ENDPOINTS.TRAVEL_REQUEST_TYPES, { params });
    },

    /**
     * Get travel request type by ID
     * @param {number} id - Travel request type ID
     * @returns {Promise} API response
     */
    getById: (id) => {
        return apiClient.get(API_ENDPOINTS.TRAVEL_REQUEST_TYPE_BY_ID(id));
    },

    /**
     * Create new travel request type
     * @param {Object} data - Travel request type data
     * @returns {Promise} API response
     */
    create: (data) => {
        return apiClient.post(API_ENDPOINTS.TRAVEL_REQUEST_TYPES, data);
    },

    /**
     * Update travel request type
     * @param {number} id - Travel request type ID
     * @param {Object} data - Travel request type data
     * @returns {Promise} API response
     */
    update: (id, data) => {
        return apiClient.put(API_ENDPOINTS.TRAVEL_REQUEST_TYPE_BY_ID(id), data);
    },

    /**
     * Delete travel request type
     * @param {number} id - Travel request type ID
     * @returns {Promise} API response
     */
    delete: (id) => {
        return apiClient.delete(API_ENDPOINTS.TRAVEL_REQUEST_TYPE_BY_ID(id));
    },

    /**
     * Toggle travel request type active status
     * @param {number} id - Travel request type ID
     * @returns {Promise} API response
     */
    toggleStatus: (id) => {
        return apiClient.patch(API_ENDPOINTS.TRAVEL_REQUEST_TYPE_TOGGLE_STATUS(id));
    },
};

export default travelRequestTypesAPI;


